export const defaultOptions = {
  disableBeacon: true,
  disableOverlayClose: true,
  hideCloseButton: true,
  spotlightClicks: true
}
